import { differenceInSeconds } from 'date-fns';
import { Metric } from 'src/app/interfaces/api/metric';

export const CraneCycle = {
    groups: [
        { name: 'Coulage', color: '#CC0000', cycles: ['benne à béton'] },
        {
            name: 'Ferraillage',
            color: '#00CC00',
            cycles: ['Armatures - CFA', 'Armatures - HA', 'Armatures - Treillis']
        },
        {
            name: 'Banchage',
            color: '#F0C300',
            cycles: [
                'préfabriqué béton poutre',
                'étais tirant-poussant',
                'banche',
                'compas banche',
                'lestes de banche'
            ]
        },
        {
            name: 'Préfabriqué',
            color: '#002aFF',
            cycles: [
                'préfabriqué béton prémur',
                'Béton préfabriqué - hourdis',
                'Préfabriqué béton balcon',
                'préfabriqué béton escalier',
                'prédalle',
                'préfabriqué béton poteau'
            ]
        },
        { name: 'Passerelle PTE', color: '#F980F4', cycles: [] },
        { name: 'Etaiements', color: '#8B44EC', cycles: [] },
        {
            name: 'Déchets',
            color: '#498bd1',
            cycles: ['benne à gravats', 'benne autovide']
        },
        { name: 'Outillage/manutention', color: '#227555', cycles: [] },
        {
            name: 'Outillage',
            color: '#227555',
            cycles: [
                'toupie', 'Trappons',
                'câbles élec', 'panier grillagé',
                'Tour de lavage', 'Embase escalib',
                'bloc béton', 'Container 20 pieds',
                'caisse bancheur', 'établi',
                'Groupe électrogène', 'Big bag',
                "support fût d'huile", 'nacelle élevatrice',
                'Podium ascenseur', 'poteau électrique',
                'Container 8 pieds', 'Bac à mortier',
                'camion', 'Sarcophage',
                "Tour d'étaiement", 'Fourche palette',
                'Palette', 'support big bag',
                'Minipelle'
            ]
        },
        { name: 'manutention', color: '#227555', cycles: [] },
        {
            name: 'Coffrage',
            color: '#cfc813',
            cycles: [
                'panneaux de contreplaqué',
                'Coffrage modulaire',
                'Mannequin',
                'Coffrage carton'
            ]
        },
        { name: 'Element structurel', color: '#d9ebd1', cycles: [] },
        { name: 'Accessibilité provisoire', color: '#645ba8', cycles: [] },
        {
            name: 'Passage provisoire',
            color: '#39B97F',
            cycles: [
                'Quai de déchargement',
                'passerelle PTE',
                'Escalib',
                'potelet garde corps',
                'échafaudage',
                'Lisse garde corps',
                'échelle',
                "Escalier d'accès provisoire"
            ]
        },
        { name: 'Autre', color: '#666666', cycles: ["Not defined", "Undefined", "Non défini"] }
    ],

    getCycleSequence(sequences: Metric[]) {
        let { tracker, unit, trackerName, unitName, payload } = sequences[0]!;
        let { startDate, group, title } = payload;
        let endDate: string = sequences[sequences.length - 1]?.payload.endDate!;
        let color = this.getColor(title!);
        let weight = sequences.reduce((p, c) => parseInt(c.payload["weight"], 10) + p, 0)
        return { 
            name: "Séquences",
            createdDate: startDate,
            tracker,
            unit,
            trackerName,
            unitName,
            payload: {
                title: group,
                label: group,
                color,
                totalWeight: `${weight}`,
                volume: `${weight / 2300}`,
                startDate,
                endDate,
                duration: differenceInSeconds(new Date(endDate), new Date(startDate!))
            }
        }
    },

    getColor (cycleName: string) {
        let sequence = this.groups.find(group => group.cycles.includes(cycleName));
        if (sequence) return sequence.color;
        return "#666666";
    },

    getGroup (cycleName: string) {
        let sequence = this.groups.find(group => group.cycles.includes(cycleName));
        if (sequence) return sequence.name;
        return "Autre";
    }
}